/* AUTAVEX — екошкіра Premium: ціни залежно від дизайну */
window.AV_EK_DZPR={
 /* група A: Ромб, Подовжений ромб, Полоси вертикаль, Полоси горизонталь */
 A:{front:2550,full:4950,trunk:3800,row3:1550,
    V:{front:46350240284808,full:46350240317576,trunk:46350240350344,row3:46350240383112}},
 /* група B: Горизонталь+ромб, Подвійний ромб, Ромб+полоси, Мала сота, Велика сота */
 B:{front:3100,full:6250,trunk:4500,row3:1900,
    V:{front:46350240415880,full:46350240448648,trunk:46350240481416,row3:46350240514184}},
 /* група C: Подвійний колір */
 C:{front:4500,full:8550,trunk:6500,row3:2500,
    V:{front:46350240546952,full:46350240579720,trunk:46350240612488,row3:46350240645256}}
};
/* який дизайн до якої групи */
window.AV_EK_DZMAP={
 '\u0420\u043e\u043c\u0431':'A',
 '\u041f\u043e\u0434\u043e\u0432\u0436\u0435\u043d\u0438\u0439 \u0440\u043e\u043c\u0431':'A',
 '\u041f\u043e\u043b\u043e\u0441\u0438 \u0432\u0435\u0440\u0442\u0438\u043a\u0430\u043b\u044c':'A',
 '\u041f\u043e\u043b\u043e\u0441\u0438 \u0433\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u044c':'A',
 '\u0413\u043e\u0440\u0438\u0437\u043e\u043d\u0442\u0430\u043b\u044c + \u0440\u043e\u043c\u0431':'B',
 '\u041f\u043e\u0434\u0432\u0456\u0439\u043d\u0438\u0439 \u0440\u043e\u043c\u0431':'B',
 '\u0420\u043e\u043c\u0431 + \u043f\u043e\u043b\u043e\u0441\u0438':'B',
 '\u041c\u0430\u043b\u0430 \u0441\u043e\u0442\u0430':'B',
 '\u0412\u0435\u043b\u0438\u043a\u0430 \u0441\u043e\u0442\u0430':'B',
 '\u041f\u043e\u0434\u0432\u0456\u0439\u043d\u0438\u0439 \u043a\u043e\u043b\u0456\u0440':'C'
};
